export default __webpack_public_path__ + "static/CloudGateway-logo-993fb527857f41baef74f529ae8359fe.png";